import { isUndefined } from 'lodash-es';
import { Children, type ReactNode } from 'react';

import { isSlot } from '../../../../core/utils/is-slot.js';
import { Icon } from '../slots/Icon.js';
import { Label } from '../slots/Label.js';
import { Legend } from '../slots/Legend.js';
import { Max } from '../slots/Max.js';
import { Min } from '../slots/Min.js';
import { Segment } from '../slots/Segment.js';
import { Tooltip } from '../slots/Tooltip.js';
import { Value } from '../slots/Value.js';
import { MultiMeterBarChartSlots } from '../types/multi-meter-bar-chart-config.js';

export function iterateSlots(children?: ReactNode) {
  const slots: MultiMeterBarChartSlots = { segments: [] };

  Children.forEach(children, (child) => {
    if (isSlot(child, Label)) {
      slots.label = child.props.children;
    } else if (isSlot(child, Icon)) {
      slots.icon = child.props.children;
    } else if (isSlot(child, Value)) {
      slots.value = {
        value: child.props.children,
        auto: isUndefined(child.props.children),
      };
    } else if (isSlot(child, Min)) {
      slots.min = {
        value: child.props.children,
        auto: isUndefined(child.props.children),
      };
    } else if (isSlot(child, Max)) {
      slots.max = {
        value: child.props.children,
        auto: isUndefined(child.props.children),
      };
    } else if (isSlot(child, Segment)) {
      const { value, color, name } = child.props;
      slots.segments = [...slots.segments, { value, color, name }];
    } else if (isSlot(child, Legend)) {
      slots.legend = true;
    } else if (isSlot(child, Tooltip)) {
      const { variant } = child.props;
      slots.tooltip = { enabled: true, variant };
    }
  });

  return slots;
}
